export interface IOffsetPaginationApi {
  page: number;
  pageSize: number;
  total: number;
}

export interface IOffsetPagination {
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
}

export interface IOffsetPaginationPayload {
  limit?: number;
  page?: number;
}

export const IOffsetPaginationMapper = {
  fromApi: (api: IOffsetPaginationApi): IOffsetPagination => {
    return {
      ...api,
      totalPages: api.pageSize > 0 ? Math.ceil(api.total / api.pageSize) : 0,
    } satisfies IOffsetPagination;
  },
};
